import './_common.js';
import '../css/before-session.scss';

function setupRegisterForm()
{
    const routes = window.app.routes;

    let form = document.querySelector('.register-form');

    form.addEventListener('submit', event => {
        event.preventDefault();

        let data = new FormData(form);
        let url = routes.BASE_REST_URL + routes.NAME_SPACE + '/' + routes.POST_EXPERT;

        let grecaptchaResponseToken = window.grecaptcha.getResponse();
        data.append('grecaptchaResponseToken', grecaptchaResponseToken);

        fetch(url, { method: 'POST', body: data }).then(response => {
            if (response.ok) {
                document.querySelector('.register-form-container').classList.add('d-none');
                document.querySelector('.register-success-container').classList.remove('d-none');

                return;
            }

            response.json().then(data => {
                if (400 !== response.status || !data.errors) {
                    return;
                }

                if (grecaptchaResponseToken) {
                    window.grecaptcha.reset();
                }

                document.querySelectorAll('.before-session-form-error').forEach(element => {
                    element.textContent = '';
                });

                data.errors.forEach(item => {
                    let selector = '.before-session-form-error.register-form-error-' + item.code;
                    let container = document.querySelector(selector);

                    if (container) {
                        container.textContent = item.message;
                    }
                })
            });
        });
    });
}

window.addEventListener('DOMContentLoaded', () => {
    setupRegisterForm();
});
